export default __webpack_public_path__ + "static/media/oxcim_new_logo.c5299edc.png";